import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog';
import { generalMessages } from 'src/utils/messages';

import type { ParkingPointsOfInterest } from 'src/features/parkingManagement/types/parking';

type DeletePointOfInterestModalProps = {
    isDeleteModalOpen: boolean;
    closeDeleteModal: (isOpen: boolean) => void;
    deletePointOfInterest: ({ id }: { id: string }) => void;
    selectedPointOfInterest: ParkingPointsOfInterest;
};

const DeletePointOfInterestModal = ({
    isDeleteModalOpen,
    closeDeleteModal,
    deletePointOfInterest,
    selectedPointOfInterest,
}: DeletePointOfInterestModalProps) => {
    const { formatMessage } = useIntl();

    return (
        <Dialog open={isDeleteModalOpen} onOpenChange={closeDeleteModal}>
            <DialogContent>
                <DialogHeader>
                    <div className="flex gap-2">
                        <SquareIcon icon={faTrashAlt} />
                        <div>
                            <DialogTitle>{formatMessage(generalMessages.delete)}</DialogTitle>
                            <DialogDescription>
                                {formatMessage(parkingManagementMessages.deleteParkingGateway, {
                                    parkingGatewayName: selectedPointOfInterest.name,
                                })}
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <p className="text-gray-500">
                        {formatMessage(parkingManagementMessages.deleteParkingGatewayConfirmation, {
                            parkingGatewayName: selectedPointOfInterest.name,
                        })}
                    </p>
                </DialogBody>
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="outline" type="button" className="flex-1">
                            {formatMessage(generalMessages.cancel)}
                        </Button>
                    </DialogClose>
                    <Button
                        variant="destructiveLight"
                        onClick={() => {
                            if (selectedPointOfInterest) {
                                return (
                                    deletePointOfInterest({ id: selectedPointOfInterest.id }),
                                    closeDeleteModal(!isDeleteModalOpen)
                                );
                            }
                        }}
                        className="flex-1"
                    >
                        {formatMessage(generalMessages.delete)}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeletePointOfInterestModal;
